import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: drawerWidth,
        borderRight: 0
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

const StyledList = styled(List)`
    margin-top: 4rem;
    padding-left: 1rem;
    @media (max-width: 599px) {
        margin-top: 0;
    }
`
const StyledListItem = styled(ListItem)`
    height: 60px;
    font-weight: 600;
    color: #868686;
    opacity: .8;
    ${({ linkactive, title }) => Boolean(linkactive === title) ? `
        color: #1474d4;
        &::before {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            width: 5px;
            height: 100%;
            background: rgba(120, 183, 94, 1)
            ` : ''}
`;

const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
`

const Sidenav = ({ window, menuItems, isDrawerOpen, toggleMenu }) => {
    const classes = useStyles();
    const [drawerOpen, toggleDrawer] = React.useState(false);
    const [isActive, setActive] = React.useState(null)
    const container = window !== undefined ? () => window().document.body : undefined;

    const { parentslug, childslug } = useParams();

    React.useEffect(() => {
        toggleDrawer(isDrawerOpen)
    }, [isDrawerOpen])
    React.useEffect(() => {
        if (menuItems && menuItems.length) {
            let title = '';
            const activePage = menuItems.find(({ slug }) => slug === `/${childslug}`)
            if (!activePage) title = menuItems[0].title;
            else title = activePage.title;
            setActive(title);
        }
    }, [menuItems, parentslug, childslug])


    const toggleSideMenu = () => {
        toggleDrawer(!drawerOpen);
        toggleMenu(false);
    }

    const onMenuClick = (item) => {
        setActive(item.title);
        // to force close the drawer
        toggleMenu(false);
        toggleDrawer(false);
    }


    const drawer = (
        <div>
            <StyledList>
                {menuItems.map((item, index) => (
                    <StyledLink to={`/${parentslug}${item.slug}`} key={`sidenav__${item.title}`}>
                        <StyledListItem button
                            key={item.title}
                            onClick={() => onMenuClick(item)}
                            title={item.title}
                            linkactive={isActive}
                            style={{ marginTop: index === 0 ? '.5rem' : 0 }}
                        >
                            {item.title}
                        </StyledListItem>
                    </StyledLink>
                ))}
            </StyledList>
        </div>
    );

    return (
        <React.Fragment>
            <nav className={classes.drawer} aria-label="mailbox folders" >
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={drawerOpen}
                        onClose={toggleSideMenu}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
        </React.Fragment>
    )
}

Sidenav.propType = {
    menuItems: PropTypes.arrayOf(PropTypes.any).isRequired,
    window: PropTypes.func,
    isDrawerOpen: PropTypes.bool,
    toggleMenu: PropTypes.func
}
Sidenav.defaulProps = {
    isDrawerOpen: false,
    toggleMenu: null
}
export default Sidenav


// WEBPACK FOOTER //
// ./src/Components/Sidenav/index.js